import { useCallback, useEffect, useState } from 'react';
import { apiUrl } from '@/config/api';

const useWalletBalance = (token, { errorMessage = '' } = {}) => {
  const [walletBalance, setWalletBalance] = useState(0);
  const [walletLoading, setWalletLoading] = useState(false);
  const [walletError, setWalletError] = useState('');

  const loadWallet = useCallback(async () => {
    if (!token) {
      setWalletBalance(0);
      setWalletLoading(false);
      setWalletError('');
      return;
    }

    setWalletLoading(true);
    setWalletError('');

    try {
      const response = await fetch(apiUrl('/api/wallet'), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || errorMessage || 'Ошибка загрузки кошелька');
      }

      const data = await response.json();
      setWalletBalance(Number(data.balance) || 0);
    } catch (error) {
      setWalletError(error.message || errorMessage || 'Ошибка загрузки кошелька');
      setWalletBalance(0);
    } finally {
      setWalletLoading(false);
    }
  }, [errorMessage, token]);

  useEffect(() => {
    loadWallet();
  }, [loadWallet]);

  return {
    walletBalance,
    walletLoading,
    walletError,
    reloadWallet: loadWallet,
    setWalletBalance,
  };
};

export default useWalletBalance;
